import React, { useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useAddAssignmentMarkMutation } from '../../features/assignmentMark/assignmentMarkApi';

const AssignmentMarkSingleTableRow = ({ data }) => {
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const { id, student_id, student_name, assignment_id, title, createdAt, totalMark, mark, repo_link, status } = data;
    const [submitMark, { isLoading, isError, isSuccess }] = useAddAssignmentMarkMutation()


    const formattedDateString = useMemo(() => {
        const date = new Date(createdAt)
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true
        };
        const formattedDateString = date.toLocaleString('en-US', options);
        return formattedDateString
    }, [createdAt])

    const onSubmit = (inputData) => {
        submitMark({
            ...data,
            status: 'published',
            mark: inputData.mark,
        })
    }

    let content = null;
    if (status === 'pending') {
        content = <td className="table-td input-mark">
            <form onSubmit={handleSubmit(onSubmit)}>
                <input step='any' max={totalMark} type='number'  {...register("mark", { required: true, max: totalMark })} />
                <button disabled={isLoading} onClick={handleSubmit}>
                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                        className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400">
                        <path strokeLinecap="round" strokeLinejoin="round"
                            d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                </button>
            </form>

        </td>
    } else {
        content = <td>
            {mark}
        </td>
    }

    return (
        <tr>
            <td className="table-td"><div title={title}>{title.slice(0, 20)}...</div></td>
            <td className="table-td">{formattedDateString}</td>
            <td className="table-td">{student_name}</td>
            <td className="table-td">{repo_link}</td>
            {content}
        </tr>
    );
};

export default AssignmentMarkSingleTableRow;